import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFeedbackFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFeedbackFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e6c276f11a6c01060b0ba88b60c25c9657908735', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '108247ab56af8081cca34db06eb1afeb24b7e478', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '16313c546d9f602026144ee7abe72a22248e744e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.022 14.973A7.05 7.05 0 0 1 2 10.009C2 6.135 5.097 3 8.925 3h4.129c1.914 0 3.634.784 4.903 2.046.301.305.58.632.817.98A7 7 0 0 1 20 9.988a7.03 7.03 0 0 1-2.946 5.747 9.1 9.1 0 0 0 1.656 2.699c.193.218.043.566-.237.566-2.15 0-4.129-.74-5.699-2.003H8.946a6.75 6.75 0 0 1-4.925-2.024", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-feedback-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-feedback-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-feedback-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFeedbackFilled$1);
            }
            break;
    } });
}

const CosmosIconFeedbackFilled = CosmosIconFeedbackFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFeedbackFilled, defineCustomElement };
